/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { css } from "@emotion/core"

export const drawerBodyWrap = css`
  padding: 24px 24px 112px;
`

export const disabledDrawerBodyWrap = css`
  pointer-events: none;
`

export const drawerFooterWrap = css`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  box-shadow: 0px -7px 34px rgba(0, 0, 0, 0.08) !important;
  padding: 20px 24px;
  background-color: #fff;
`

export const prepareStep = css`
  list-style: disc;
  margin-left: 24px;

  li {
    margin-bottom: 10px;
  }

  span.download {
    color: #136fd8;
    text-decoration: underline;
    cursor: pointer;
  }

  button {
    margin: 12px 0;
  }
`

export const prepareTitle = css`
  margin: 32px 0 !important;
`
export const divider = css`
  margin: 32px 0;
`

export const detailedInstuction = css`
  color: #136fd8;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 24px;
`

export const orText = css`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
`

export const modalContent = css`
  .ant-modal-content {
    width: fit-content;
    max-width: 100vw;
  }
  .ant-modal-body {
    padding: 0;
  }
`

export const bulkItemUI = css`
  max-width: 100vw;
  overflow-x: auto;
`
